import React from "react";
import { NoteType } from "@rebuild/shared";
import { FilterableSelect } from "../../../pages/components/GenericInputComponents";

interface NoteTypeSelectorProps {
	value: NoteType;
	onChange: (value: NoteType) => void;
	label?: string;
}

const NoteTypeSelector: React.FC<NoteTypeSelectorProps> = ({ value, onChange, label = "Note Type" }) => {
	return (
		<div>
			<label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
			<FilterableSelect
				options={Object.values(NoteType)}
				value={value}
				onSelect={(newValue) => {
					if (newValue) {
						onChange(newValue as NoteType);
					} else {
						onChange(NoteType.MITIGATION);
					}
				}}
			/>
		</div>
	);
};

export default NoteTypeSelector;
